const adSubDirectory = "/Ads";

export const getRandomAd = `${adSubDirectory}/GetRandomAd`;
